/**
 * Customize the navigation bar for logged-in users and guests
 */

// Get current user data from LOGGEDIN cookie and return needed information
function getLoggedUserDataByCookies() {
  const value = "; " + document.cookie;
  let parts = value.split("; " + "LOGGEDIN" + "=");
  if (parts.length === 2) {
      const userCookie = parts.pop().split(";").shift().replace(/[^A-Za-z0-9\+\/\=]/g, "");
      const userString = decodeURIComponent(escape(atob(userCookie))); //added decodeURIComponent & escape to decode PL
      const userData = userString.split('|');
      return {
        'userName': (userData[3] === "business") ? userData[2] : userData[1],
        'issuer': userData[4],
        'mailboxId': userData[5]
      };
  }
}

// Adjust displayed information based on data from cookie
(function setMenuOfUserByLoginStatus() {
  let cookieExist = (document.cookie.match(/^(?:.*;)?\s*LOGGEDIN\s*=\s*([^;]+)(?:.*)?$/) || ['null'])[1];
  if (cookieExist) {
      document.querySelector('.current-user-menu-wrapper').classList.remove('d-none');
      document.querySelector('.account, .account-mobile').classList.add('d-none');

      let secondLetter = "";
      const userSelector = document.querySelector(".currentUser > .menu-item-wrapper > a .initials");
      const userData = getLoggedUserDataByCookies();
      const userName = userData.userName;

      // Show/hide menu elements based on issuer/nonissuer value
      const splitName = userName.toUpperCase().split(" ");
      if (userData.issuer === 'nonissuer') {
          [...document.querySelectorAll('.nonissuer')].forEach(elem => elem.style.display = "block");
      } else if(userData.issuer === 'issuer') {
          [...document.querySelectorAll('.issuer')].forEach(elem => elem.style.display = "block");
      }

      // Create user initials
      let userLetters = [];
      for (let i = 0; i < splitName.length; i++) {
          if (/[A-Z]/.test(splitName[i])) {
              userLetters.push(splitName[i].substring(0, 1));
          } else {
              userLetters.push("J", "a");
          }

      }
      if (splitName.length > 1) secondLetter = userLetters[1];

      userSelector.innerText = "";
      userSelector.innerText = userLetters[0] + secondLetter;

      const userID = userData.mailboxId;
      const userIDField = document.querySelector(".user-id a");
      userIDField ? userIDField.innerText = "Envelo ID: " + userID : '';

  } else {
    document.querySelectorAll('.account, .account-mobile').forEach(item => item.classList.remove('d-none'));
  }
})();